import React, { useContext } from "react";
import "./SignUp.css";
import firebase from "firebase/app";
import "firebase/auth";
import { firebaseConfig } from "../firebase.config";
import { userContext } from "../../App";
import { Link } from "react-router-dom";
import Google from "../../images/g.png";

function SignUp() {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }
  const [signInUser, setSignInUser] = useContext(userContext);
  const handelGoogleSignIn = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        const { displayName, email } = result.user;
        const newUser = { name: displayName, email };
        const newUserInfo = { ...signInUser };
        newUserInfo.error = "";
        newUserInfo.success = true;
        newUserInfo.name = newUser.name;
        setSignInUser(newUserInfo);
      })
      .catch((error) => {
        const newUserInfo = { ...signInUser };
        newUserInfo.error = error.message;
        newUserInfo.success = false;
        setSignInUser(newUserInfo);
      });
  };
  const handelBlur = (e) => {
    let isFiledValid = true;
    if (e.target.name === "email") {
      isFiledValid = /\S+@\S+\.\S+/.test(e.target.value);
    }
    if (e.target.name === "password") {
      const isPasswordLength = e.target.value.length > 5;
      const isPasswordNumber = /\d{1}/.test(e.target.value);
      isFiledValid = isPasswordLength && isPasswordNumber;
    }
    if (isFiledValid) {
      const newUserInfo = { ...signInUser };
      newUserInfo[e.target.name] = e.target.value;
      setSignInUser(newUserInfo);
    }
  };
  const handelSubmit = (e) => {
    if (signInUser.email && signInUser.password) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(signInUser.email, signInUser.password)
        .then((res) => {
          const newUserInfo = { ...signInUser };
          newUserInfo.error = "";
          newUserInfo.success = true;
          setSignInUser(newUserInfo);
          updateUserInfo(signInUser.name);
        })
        .catch((error) => {
          const newUserInfo = { ...signInUser };
          newUserInfo.error = error.message;
          newUserInfo.success = false;
          setSignInUser(newUserInfo);
        });
    }
    e.preventDefault();
  };
  const updateUserInfo = (name) => {
    var user = firebase.auth().currentUser;

    user
      .updateProfile({
        displayName: name,
        photoURL: "https://example.com/jane-q-user/profile.jpg",
      })
      .then(function () {
        // Update successful.
      })
      .catch(function (error) {
        // An error happened.
      });
  };
  return (
    <div className="login">
      <div className="from mt-5">
        <h2 className="mt-3 mb-5">Create an account</h2>
        <form onSubmit={handelSubmit}>
          <input
            style={{ width: "400px", marginBottom: "20px" }}
            className="input-box"
            placeholder="Name"
            type="text"
            name="name"
            onBlur={handelBlur}
            required
          />
          <br />
          <input
            style={{ width: "400px", marginBottom: "20px" }}
            className="input-box"
            placeholder="User Name or Email"
            type="email"
            name="email"
            onBlur={handelBlur}
            required
          />
          <br />
          <input
            style={{ width: "400px", marginBottom: "10px" }}
            placeholder="Password"
            type="password"
            name="password"
            className="input-box"
            onBlur={handelBlur}
            required
          />
          <br />
          <br />
          <input
            style={{ width: "400px", marginBottom: "10px" }}
            placeholder="Confirm Password"
            type="password"
            className="input-box"
            required
          />
          <br />
          <input className="main-btn" type="submit" value="Create an account" />
          <p style={{}}>
            Already have an account?
            <Link to="/login">
              <span style={{ textDecoration: "underline" }}>Link</span>
            </Link>
          </p>
          <br />
        </form>
        <p style={{ textAlign: "center", color: "red" }}>{signInUser.error}</p>
        {signInUser.success && (
          <p style={{ textAlign: "center", color: "green" }}>
            User create Successfully
          </p>
        )}
      </div>
      <div className="d-flex justify-content-center mt-3">
        <hr
          style={{
            backgroundColor: "white",
            fontWeight: "bold",
            width: "200px",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        />
        <p style={{ margin: "0px 10px" }}>0r</p>
        <hr
          style={{
            backgroundColor: "white",
            fontWeight: "bold",
            width: "200px",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        />
      </div>
      <div className="other-login">
        <button onClick={handelGoogleSignIn}>
          <img style={{ height: "30px", width: "40px" }} src={Google} alt="" />
        </button>
      </div>
    </div>
  );
}

export default SignUp;
